import {ServicePublic} from '@yandex-data-ui/cloud-schemas/build/models/ui-api';
import {GetSolutionListRequest} from '@yandex-data-ui/cloud-schemas/build/schemas/solutions/types';
import {GetSolutionListResponse} from './models';
import {request} from 'api';
import {LocaleData} from 'contexts/LocaleContext';

export function getSolutions({lang, region}: LocaleData, params: GetSolutionListRequest) {
    return request<GetSolutionListResponse>({
        method: 'GET',
        url: '/api/solutions',
        params: {lang, region, ...params},
    });
}

export function getServicesBySolution({lang, region}: LocaleData, solutionId: number) {
    return request<ServicePublic[]>({
        method: 'GET',
        url: '/api/solutions/servicesBySolution',
        params: {lang, region, solutionId},
    });
}
